<template>
  <!--境外展会-->
  <div style="width: 100%;height: auto;display: flex;flex-direction: column;align-items: center;padding-bottom: 100px;padding-top: 60px;">
    <Breadcrumb :value="[$t('h.tabName1'),$t('h.tabName5'),$t('h.tabName5Item4')]"/>
    <div style="width: 1200px;height: auto;padding: 0 12px;display: flex;flex-direction: column;align-items: center;">
      <div class="baseTitle"
           style="padding: 60px 0;">
        {{ $t('h.custom.ExhibitionNotice') }}
      </div>
      <div style="display: flex;">
        <div style="width: 637px;height: 390px;margin-right: 12px;overflow: hidden;border-radius: 12px;">
          <img src="@/assets/img/jingwaizhanhui.jpg" class="customImage"/>
        </div>
        <div
            style="width: 527px;height: 390px;background: #FAFAFA;border-radius: 12px;padding: 60px 30px;display: flex;flex-direction: column;">
          <div style="font-family: PingFangSC-Medium;font-size: 20px;color: #212121;padding-bottom: 40px;">
            {{ $t('h.custom.RecentActivities') }}
          </div>
          <div style="overflow-y: scroll;">
            <div v-for="(item,index) in eventsList[$language === 'ZH' ? 'zh':'en']" :key="index"
                :style="$language === 'ZH' ? 'height: 94px;':'height: 74px;'" style="display: flex;margin-bottom: 10px;">
              <div style="width: 24px;margin-right: 20px;display: flex;flex-direction: column;align-items: center;">
                <img style="width: 24px;height: 24px;" src="@/assets/img/shijianred.png"/>
                <div style="width: 1px;height: 34px;background: #F0831E;margin-top: 10px;"></div>
              </div>
              <div style="height: 100%;display: flex;flex-direction: column;justify-content: space-between;">
                <div class="customLabel"
                     style="font-family: PingFangSC-Medium;font-size: 16px;color: #444444;text-align: left;line-height: 24px;">
                  {{ item[$language === 'ZH' ? 'title' : 'subTitle'] }}
                </div>
                <div style="font-family: PingFangSC-Regular;font-size: 14px;color: #666666;line-height: 22px;">
                  <div v-if="$language === 'ZH'" style="font-size: 12px;">{{ item[$language === 'ZH' ? 'subTitle' : 'title'] }}</div>
                  <div style="font-size: 12px;">{{ $t('h.custom.Time') }}：{{ item.time }}</div>
                  <div style="font-size: 12px;">{{ $t('h.custom.Location') }}：{{ item.address }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="baseTitle"
           style="padding-top: 100px;padding-bottom: 60px;">
        {{ $t('h.custom.ExhibitionVisitConsultation') }}
      </div>
      <Linkage style="width: 100%;padding: 0 12px;" :list="linkageInfo"></Linkage>
      <!--      <div style="display: flex;height: 300px;width: 100%;padding: 0 12px;">-->
      <!--        <div class="customCard"-->
      <!--             style="flex: 1;height: 100%;background: #F5F5F5;display: flex;flex-direction: column;justify-content: space-between;">-->
      <!--          <div-->
      <!--              style="font-family: SourceHanSansOLD-Bold;font-size: 24px;color: #212121;padding: 40px 40px 0 40px;">-->
      <!--            {{ value1 }}-->
      <!--          </div>-->
      <!--          <div style="display: flex;justify-content: space-between;align-items: flex-end;">-->
      <!--            <div-->
      <!--                style="display: flex;flex-direction: column;font-family: SourceHanSansCN-Medium;font-size: 20px;color: #444444;line-height: 32px;padding: 0 0 40px 40px;">-->
      <!--              <div> {{ value2 }}</div>-->
      <!--              <div> {{ value3 }}</div>-->
      <!--              <div> {{ value4 }}</div>-->
      <!--              <div> {{ value5 }}</div>-->
      <!--            </div>-->
      <!--            <img style="width: 108px;height: 108px;margin-right: 40px;margin-bottom: 45px;"-->
      <!--                 src="@/assets/img/OverseasExhibition/QRcode.png"/>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div style="width: 24px;"></div>-->
      <!--        <div-->
      <!--             style="flex: 1;height: 100%;">-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import {linkage} from "../../../assets/api";
import Linkage from "../../components/Linkage";

export default {
  name: "OverseasExhibition",
  components: {
    Linkage
  },
  data() {
    return {
      value1: this.$t('h.custom.CableCloudPrevContactUsCompany'),
      value2: this.$t('h.custom.CableCloudPrevContactUsTitle'),
      value3: this.$t('h.custom.CableCloudPrevContactUsName'),
      value4: this.$t('h.custom.CableCloudPrevContactUsPhone'),
      value5: this.$t('h.custom.CableCloudPrevContactUsEmail'),
      eventsList: {
        zh: [
          {
            title: "EnlitAsia亚洲国际电力能源展览会",
            subTitle: "Enlit Asia",
            time: "2026.9.22-9.24",
            address: "ICE印尼会展中心",
          },
          {
            title: "POWEREXPO ALMATY 2026哈萨克斯坦国际电力、能源及照明展",
            subTitle: "POWEREXPO ALMATY 2026",
            time: "2026.10.21-10.23",
            address: "哈萨克斯坦Atakent国际展览中心",
          },
          {
            title: "Wire & Cable Show Vietnam越南国际电线及设备展",
            subTitle: "Wire & Cable Show Vietnam",
            time: "2026.11.25-11.27",
            address: "河内VEC展览中心-新馆",
          },
          {
            title: "wire India印度国际线缆及线材展览会",
            subTitle: "wire India",
            time: "2026.11.30-12.02",
            address: "印度·孟买",
          },
          {
            title: "wire Mexico 2027墨西哥国际线缆及线材展览会",
            subTitle: "wire Mexico 2027",
            time: "2027.2.23-2.25",
            address: "墨西哥·蒙特雷",
          },
          {
            title: "CABEX 2027俄罗斯(莫斯科)国际电线电缆展览会",
            subTitle: "CABEX 2027",
            time: "2027.3.02-3.04",
            address: "俄罗斯·莫斯科",
          },
          {
            title: "wire Eurasia 2027欧亚国际线缆及线材展览会",
            subTitle: "wire Eurasia 2027",
            time: "2027.4.07-4.10",
            address: "土耳其·伊斯坦布尔",
          },
          {
            title: "Wire & Cable Show Philippines 2027菲律宾国际电力、电线电缆及设备材料展",
            subTitle: "Wire & Cable Show Philippines 2027",
            time: "2027.6.16-6.18",
            address: "菲律宾马尼拉SMX展览中心",
          },
          {
            title: "Wire&Cable Show Malaysia 2027马来西亚国际线缆及设备展览会",
            subTitle: "Wire&Cable Show Malaysia 2027",
            time: "2027.8.19-8.21",
            address: "马来西亚-吉隆坡MITEC",
          },
          {
            title: "wire Middle East Africa 2027中东及非洲国际线缆及线材展览会",
            subTitle: "wire Middle East Africa 2027",
            time: "2027.9.04-9.06",
            address: "埃及·开罗",
          },
          {
            title: "wire Southeast Asia 2027东南亚国际线缆及线材展览会",
            subTitle: "wire Southeast Asia 2027",
            time: "2027.9.15-9.17",
            address: "泰国·曼谷",
          },
          {
            title: "wire Duesseldorf 2028杜塞尔多夫国际线缆及线材展览会",
            subTitle: "wire Duesseldorf 2028",
            time: "2028.4.03-4.07",
            address: "德国·杜塞尔多夫",
          }
],
        en: [{
          title: "wire India 2026",
          subTitle: "wire India 2026",
          time: "2026.11.30 - 12.2",
          address: this.$t('h.custom.ExhibitionLocation1'),
          },
          {
            title: "wire Mexico 2027",
            subTitle: "wire Mexico 2027",
            time: "2027.2.23 - 25",
            address: this.$t('h.custom.ExhibitionLocation2'),
          },
          {
            title: "wire Eurasia 2027",
            subTitle: "wire Eurasia 2027",
            time: "2027.4.7 - 10",
            address: this.$t('h.custom.ExhibitionLocation3'),
          },
          {
            title: "Urban Steel Expo",
            subTitle: "Urban Steel Expo",
            time: "2027.4.20 - 23",
            address: this.$t('h.custom.ExhibitionLocation5'),
          },
          {
            title: "wire Middle East Africa",
            subTitle: "wire Middle East Africa",
            time: "2027.9.4 - 6",
            address: this.$t('h.custom.ExhibitionLocation4'),
          },
          {
            title: "wire South East Asia 2027",
            subTitle: "wire South East Asia 2027",
            time: "2027.9.15 - 17",
            address: this.$t('h.custom.ExhibitionLocation7'),
          },
          {
            title: "metaflow ALLIANCE Saudi Arabia 2027",
            subTitle: "metaflow ALLIANCE Saudi Arabia 2027",
            time: "2027.10",
            address: this.$t('h.custom.ExhibitionLocation6'),
          },
          {
            title: "wire Düsseldorf 2028",
            subTitle: "wire Düsseldorf 2028",
            time: "2028.4.3 - 7",
            address: this.$t('h.custom.ExhibitionLocation8'),
          }]
      },
      dataSource: [],
      columns: [],
      linkageInfo: []
    }
  },
  created() {
    this.initConfig()
  },
  methods: {
    initConfig() {
      this.$axios.get(linkage + '10').then(res => {
        this.linkageInfo = res && res.data.success ? res.data.result : []
        // 英文联系方式改为静态内容
        if (this.$language === 'EN' && this.linkageInfo.length > 0) {
          this.linkageInfo = [{
            title: this.linkageInfo[0].title,
            titleEn: 'Mr. Alex Gu',
            company: this.linkageInfo[0].company,
            companyEn: 'Messe Düsseldorf (Shanghai) Co., Ltd.',
            name: this.linkageInfo[0].name,
            nameEn: '',
            phone: '+86 021 6169 8373',
            email: 'alex.gu@mds.cn',
            mobile: '',
            qrcode: null
          }]
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>

